import { SinisterSector } from "./sectorOptions";

export type SinisterStage =
	| "pre_sinister"
	| "post_sinister"
	| "credit_recovery"
	| "action_filed"
	| "extrajudicial_action"
	| "debt_confession"
	| "procedural_progress";

export const STAGE_OPTIONS_BY_SECTOR: Record<SinisterSector, { value: SinisterStage; label: string }[]> = {
	cobranca: [
		{ value: "pre_sinister", label: "Pré Sinistro" },
		{ value: "post_sinister", label: "Desocupação" },
		{ value: "credit_recovery", label: "Recuperação de Crédito" },
	],
	juridico: [
		{ value: "action_filed", label: "Ação Distribuída" },
		{ value: "extrajudicial_action", label: "Ação Extrajudicial" },
		{ value: "debt_confession", label: "Confissão de Dívidas" },
		{ value: "procedural_progress", label: "Andamento Processual" },
	],
};

export const ALL_STAGE_OPTIONS = [...STAGE_OPTIONS_BY_SECTOR.cobranca, ...STAGE_OPTIONS_BY_SECTOR.juridico];

export const getStageLabel = (stage?: SinisterStage | string | null): string => {
	if (!stage) return "—";
	return ALL_STAGE_OPTIONS.find((option) => option.value === stage)?.label ?? stage;
};
